import DaasTableRowCell from '@/components/table/DaasTableRowCell';
import { usePrintCurrencyStringForCurrentCustomer } from '@/utils/price';
import { FunctionComponent } from 'react';
import { PurchaseOrderConfirmOrderDeviceFeeTableData } from './PurchaseOrderConfirmOrderDeviceFeeTable';

interface Props {
  data: PurchaseOrderConfirmOrderDeviceFeeTableData;
}

export const PurchaseOrderConfirmOrderDeviceFeeTableRow: FunctionComponent<Props> = ({ data }) => {
  const printCurrencyString = usePrintCurrencyStringForCurrentCustomer();
  const feeCost = printCurrencyString(data.feePerDevice);
  const totalCost = printCurrencyString(data.totalFee);

  return (
    <>
      <DaasTableRowCell>{data.deviceName}</DaasTableRowCell>
      <DaasTableRowCell>{data.quantity}</DaasTableRowCell>
      <DaasTableRowCell>{feeCost}</DaasTableRowCell>
      <DaasTableRowCell>{totalCost}</DaasTableRowCell>
    </>
  );
};
